module.exports = __webpack_public_path__ + "static/media/018.a787fedf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/018.jpg
// module id = 525
// module chunks = 0